import {
  SELF_GUIDED_TRIP_DETAIL_START,
  SELF_GUIDED_TRIP_DETAIL_SUCCESS,
  SELF_GUIDED_TRIP_DETAIL_ERROR,
} from "Constant/RentalCustomer";

const initialState = {
  loading: false,
  data: [],
};

export default function selfGuidedTripDetailReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case SELF_GUIDED_TRIP_DETAIL_START:
      return {
        ...state,
        loading: true,
      };
    case SELF_GUIDED_TRIP_DETAIL_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case SELF_GUIDED_TRIP_DETAIL_ERROR:
      return {
        ...state,
        loading: false,
        message: action.error.message,
      };
    default:
      return state;
  }
}
